<template>
  <nav aria-label="Page navigation">
    <ul class="pagination admin-pagination">
      <li :class="{ 'disabled': isFirstPage }" class="spec-prev-button">
        <a href="javascript: void(0);" aria-label="Previous" @click="previousPage()">
          <span aria-hidden="true">&laquo;</span>
        </a>
      </li>
      <li>
        <a href="javascript: void(0);" class="spec-first-page-button" aria-label="First Page"
           @click="selectPage(1)" v-if="currentPage > 3"
        >
          <span aria-hidden="true">1</span>
        </a>
      </li>
      <li class="disabled" v-if="currentPage > 4">
        <a><span>...</span></a>
      </li>
      <li v-for="page in pages" v-if="showFlag">
        <a href="javascript: void(0);" :class="{ 'page--selected': page == currentPage, 'spec-page-button': true }"
           @click="selectPage(page)"
        >{{ page }}</a>
      </li>
      <li class="disabled" v-if="totalPages > 5 && currentPage < (totalPages - 1)">
        <a><span>...</span></a>
      </li>
      <li>
        <a href="javascript: void(0);" class="spec-last-page-button" aria-label="Last Page"
           @click="selectPage(totalPages)" v-if="totalPages > 3 && currentPage < (totalPages - 1)"
        >
          <span aria-hidden="true">{{ totalPages }}</span>
        </a>
      </li>
      <li :class="{ 'disabled': isLastPage }" class="spec-next-button">
        <a href="javascript: void(0);" aria-label="Next" @click="nextPage()">
          <span aria-hidden="true">&raquo;</span>
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
import _ from 'lodash';

export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['totalPages'],
  data() {
    return {
      currentPage: 1,
      window: 2,
      showFlag: true,
    };
  },
  computed: {
    pages() {
      const firstPage = Math.max(this.currentPage - this.window, 1);
      const lastPage = Math.min(this.currentPage + this.window, this.totalPages) + 1;
      return _.range(firstPage, lastPage);
    },
    isFirstPage() {
      return this.currentPage === 1;
    },
    isLastPage() {
      return this.currentPage === this.totalPages;
    },
  },
  methods: {
    selectPage(page) {
      this.showFlag = false;
      this.currentPage = page;
      this.$emit('page-changed', page);
      this.$nextTick(() => {
        this.showFlag = true;
      });
    },
    previousPage() {
      if (!this.isFirstPage) {
        this.selectPage(this.currentPage - 1);
      }
    },
    nextPage() {
      if (!this.isLastPage) {
        this.selectPage(this.currentPage + 1);
      }
    },
    reset() {
      this.currentPage = 1;
    },
  },
};
</script>

<style lang="scss" scoped>
.admin-pagination {
  margin: 0;
}
</style>
